import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { LOYALTY_PROGRAMME_NAME } from '@/Constants'
import { FooterLinksObj } from '@/data'

interface FooterProps {
    parentClassname?: string
    className?: string
    customFooter?: React.ReactNode
}

export default function Footer({ parentClassname, className, customFooter }: FooterProps) {
    return (
        <footer className="text-center w-full">
            {customFooter ||
                <div className={cn(
                    'w-full p-3',
                    parentClassname
                )}>
                    <div className='w-full text-xs text-primary-color/70'>
                        {`By continuing, you agree to ${LOYALTY_PROGRAMME_NAME}'s `}
                        <Link
                            to={FooterLinksObj.TERMS_AND_CONDITIONS.to}
                            className={cn(
                                "font-bold hover:text-accent hover:underline transition-colors duration-200",
                                className
                            )}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            {FooterLinksObj.TERMS_AND_CONDITIONS.name}
                        </Link>
                        {" and "}
                        <Link
                            to={FooterLinksObj.PRIVACY_POLICY.to}
                            className={cn(
                                "font-bold hover:text-accent hover:underline transition-colors duration-200",
                                className
                            )}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            {FooterLinksObj.PRIVACY_POLICY.name}
                        </Link>.
                    </div>
                </div>
            }
        </footer>
    )
} 